import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { Button } from 'primeng/button'

import { DeviceService, MaintenanceEnforcer } from '@ti/core/common/services'

@Component({
  selector: 'app-maintenance-page',
  templateUrl: 'maintenance-page.component.html',
  styleUrl: 'maintenance-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, Button, TranslatePipe],
})
export class MaintenancePageComponent {
  protected readonly deviceService = inject(DeviceService)
  protected readonly maintenanceEnforcer = inject(MaintenanceEnforcer)

  protected reload() {
    return this.maintenanceEnforcer.reloadApp()
  }
}
